import { Box, BoxProps, ButtonProps, Text } from '@chakra-ui/react';
import { SyntheticEvent, useMemo } from 'react';

import { parseStringForDynamicContent } from '../utils/helpers';
import Button from './ui/buttons/Button';

type DynamicContentHandler = {
  content: string;
  onClick: (e: SyntheticEvent) => void;
  trackClick?: string;
};

type Props = BoxProps & {
  content: string;
  dynamicContentHandlers?: DynamicContentHandler[];
  handlerProps?: ButtonProps;
};

const DynamicLinkContent = ({ content, dynamicContentHandlers, handlerProps, ...props }: Props) => {
  const parsedContent = useMemo(() => {
    const parsed = parseStringForDynamicContent(content || '');
    return parsed;
  }, [content]);

  const handlersByContent = useMemo(
    () => new Map((dynamicContentHandlers ?? []).map((h) => [h.content, h])),
    [dynamicContentHandlers],
  );

  const renderDynamicContent = (dynamicContent: string, index: number) => {
    const handler = handlersByContent.get(dynamicContent);

    if (handler) {
      return (
        <Button
          key={`${dynamicContent}-${index}`}
          variant="link"
          display="inline"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handler.onClick(e);
          }}
          trackClick={handler.trackClick}
          {...handlerProps}
        >
          {dynamicContent}
        </Button>
      );
    }

    return (
      <Text key={`${dynamicContent}-${index}`} display="inline">
        {dynamicContent}
      </Text>
    );
  };

  return (
    <Box minW={{ base: '250px', md: '450px' }} {...props}>
      {parsedContent.strings.map((textSegment, index) => {
        const dynamicContent = parsedContent.dynamicContents[index];
        return (
          // eslint-disable-next-line react/no-array-index-key
          <span key={`segment-${index}`}>
            {textSegment}
            {dynamicContent && renderDynamicContent(dynamicContent.content, index)}
          </span>
        );
      })}
    </Box>
  );
};

export default DynamicLinkContent;
